import React from 'react';
import { Row, Col, CardBody } from 'reactstrap';
import { Line } from 'react-chartjs-2';
import {
  BaseCardChartContainer,
  BaseChartCardHeaderContainer,
  BaseChartContainer
} from './common-charts-styles';

export function TotalProtocolsOpenOverTime({ protocolData }) {
  const options = {
    scales: {
      y: {
        beginAtZero: true,
        ticks: {
          stepSize: 3
        }
      }
    }
  };

  return (
    <Row>
      <Col xl="12">
        <BaseCardChartContainer>
          <BaseChartCardHeaderContainer>
            <h5 className="h3 mb-0">Protocolos em aberto por dia</h5>
          </BaseChartCardHeaderContainer>
          <CardBody>
            <BaseChartContainer className="chart">
              <Line
                data={protocolData.data}
                options={options}
                className="chart-canvas"
                id="chart-bars"
              />
            </BaseChartContainer>
          </CardBody>
        </BaseCardChartContainer>
      </Col>
    </Row>
  );
}
